import { BaseModel } from '../../core/abstractions/base.model';

export class RepositoryConfigModel extends BaseModel {
    tableName: string;
    index?: string;
    isIndexUnique = false;
    canSyncUp = true;
    keyPath = 'id';
    autoIncrement = false;

    constructor(init: Partial<RepositoryConfigModel>) {
        super();
        Object.assign(this, init);
    }
}
